import { render, staticRenderFns } from "./RegistrationConfirmation.vue?vue&type=template&id=25a8162e&scoped=true&"
import script from "./RegistrationConfirmation.vue?vue&type=script&lang=js&"
export * from "./RegistrationConfirmation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25a8162e",
  null
  
)

export default component.exports